import { TaskType } from '../types';
import { MmcIcon, DetIcon, PlateIcon } from '../components/DrawerNavigation';

// Icon props interface
export interface IconProps {
  size?: number;
}

// Task type configuration item
export interface TaskTypeConfigItem {
  label: string;
  shortLabel: string;
  description: string;
  icon: React.FC<IconProps>;
  color: string;
  bgColor: string;
  darkBgColor: string;
}

// Centralized task type configuration
export const TASK_TYPE_CONFIG: Record<TaskType, TaskTypeConfigItem> = {
  mmc: {
    label: 'Make, Model & Color',
    shortLabel: 'MMC',
    description: 'Annotate vehicle make, model, and color information',
    icon: MmcIcon,
    color: '#1976d2',
    bgColor: '#e3f2fd',
    darkBgColor: 'rgba(25, 118, 210, 0.12)',
  },
  detection: {
    label: 'Detection',
    shortLabel: 'Detection',
    description: 'Draw vehicle and plate bounding boxes',
    icon: DetIcon,
    color: '#9c27b0',
    bgColor: '#f3e5f5',
    darkBgColor: 'rgba(156, 39, 176, 0.12)',
  },
  plate: {
    label: 'Plate Annotation',
    shortLabel: 'Plate',
    description: 'Annotate plate tag and region information',
    icon: PlateIcon,
    color: '#ff9800',
    bgColor: '#fff3e0',
    darkBgColor: 'rgba(255, 152, 0, 0.12)',
  },
};

// Dataset type configuration (extends task type config for dataset-specific labels)
export interface DatasetTypeConfigItem {
  label: string;
  icon: React.FC<IconProps>;
  color: string;
  bgColor: string;
  darkBgColor: string;
}

export const DATASET_TYPE_CONFIG: Record<TaskType, DatasetTypeConfigItem> = {
  mmc: {
    label: 'MMC Datasets',
    icon: MmcIcon,
    color: '#1976d2',
    bgColor: '#e3f2fd',
    darkBgColor: 'rgba(25, 118, 210, 0.12)',
  },
  detection: {
    label: 'Detection Datasets',
    icon: DetIcon,
    color: '#9c27b0',
    bgColor: '#f3e5f5',
    darkBgColor: 'rgba(156, 39, 176, 0.12)',
  },
  plate: {
    label: 'Plate Datasets',
    icon: PlateIcon,
    color: '#ff9800',
    bgColor: '#fff3e0',
    darkBgColor: 'rgba(255, 152, 0, 0.12)',
  },
};

// Helper to get theme-aware background color
export const getTaskBgColor = (type: TaskType, mode: 'light' | 'dark'): string => {
  const config = TASK_TYPE_CONFIG[type] || TASK_TYPE_CONFIG.mmc;
  return mode === 'dark' ? config.darkBgColor : config.bgColor;
};

// Helper function to get task type config
export const getTaskTypeConfig = (type: TaskType): TaskTypeConfigItem => {
  return TASK_TYPE_CONFIG[type] || TASK_TYPE_CONFIG.mmc;
};

// Helper function to get dataset type config
export const getDatasetTypeConfig = (type: TaskType): DatasetTypeConfigItem => {
  return DATASET_TYPE_CONFIG[type] || DATASET_TYPE_CONFIG.mmc;
};
